// extracted by mini-css-extract-plugin
export var container = "_im-1";
export var cornerButtonContainer = "_im-6";
export var disabled = "_im-2";
export var dragActive = "_im-3";
export var fileContainer = "_im-5";
export var hiddenInput = "_im-4";
export var widthContainer = "_im-0";